
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexeerc6nPuGysHs_2M9eoyL6VRlO9SqyghBPG9in5YwwIMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/index.vue?macro=true";
import { default as _91id_93lpe0miuBzBWZzM_45B8ganKDe_45mZmoqLzL_1R3oXzGTMcMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/caja/[id].vue?macro=true";
import { default as indexXQE_45CG2PHpAogWsUPJHTyfQo_mGLQg5x2AM1T1URib4Meta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/auth/index.vue?macro=true";
import { default as _91id_93kywlAg8q_45gS89vyKovD4MF1hSw5dhEv6we16MPj92SIMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/barra/[id].vue?macro=true";
import { default as _91id_937yyh6djsnkOI_45vp0Z3fqtWjsWF3MmTPUY9T9Fko996sMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/mesas/[id].vue?macro=true";
import { default as onboarding4T2bwyhQtVveZ89q9gES_8lTImRYc5CjYqYuYdtk9YUMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/onboarding.vue?macro=true";
import { default as _91id_93_45r_45_45jOpkBSOCdGLrTh9yNXQJOc7tYV3Z0f__wIBvV78Meta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/salon/[id].vue?macro=true";
import { default as _91id_93uiyQJ1RbTOyJPz03thIIa0zk_X61hjOSxLrLMSBgcKUMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/stock/[id].vue?macro=true";
import { default as _91id_939BmAbi1lYHczflvIv6gaGjCN7g3pWh23HeNt1TLcedwMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/equipo/[id].vue?macro=true";
import { default as multi_45localLQwEccVAuNRCBWd5Z9zD6IlmikHQA206wHV7nW0fAUQMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/multi-local.vue?macro=true";
import { default as nuevo_45local333QLsD3xRb7_0VoYx9B5FjXRHr0LW5jJsa9sl30m_sMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/nuevo-local.vue?macro=true";
import { default as _91id_93ApIeJ3XXPuX5bNNWVSO_45P_1ii7JFH_MmIhxyspxRcxgMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/perfil/[id].vue?macro=true";
import { default as _91id_93ykWJnA_JB3iPwCmpZ9sKHk1IxcVQypXW0yLjU_45d07t8Meta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/recibo/[id].vue?macro=true";
import { default as test_45sentry57T_YvUG_aVOAsZah5MAZKdi7ftMRuxk9hUMf_as2zgMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/test-sentry.vue?macro=true";
import { default as _91id_93TCU8J5_45jkjARKgZ2w8_qaNRKvSZ_45_45qGB_45I0r2y07X4EMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/ajustes/[id].vue?macro=true";
import { default as confirmqgE7GQnocGk4kn2wmsAx273YqtGn9djaQWI23aQu6AUMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/auth/confirm.vue?macro=true";
import { default as _91id_93gCPeE7mrDUHHTG6oHmCIRrex_451ZbQ6SbDX_pVeYkS5YMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/pedidos/[id].vue?macro=true";
import { default as cookiesBd_45YbbIdTtYejfrvjvpzvhS1bbsACLBsuvYyzeo71VUMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/legal/cookies.vue?macro=true";
import { default as _91id_93ZeBZbLd9kBy9I78LAqokSP8CY1G6IGCj7qPpTIdJBbwMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/analytics/[id].vue?macro=true";
import { default as create_45profilecKP2fQ5zBcdIi9qO0_45Z7f5rKc4voh_BorgyJzlkRw5gMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/create-profile.vue?macro=true";
import { default as _91id_93_45ArsxiH_RrJwJT5T1EUMZ_45ydqbfmnaIac07NdcLgg0wMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/dashboard/[id].vue?macro=true";
import { default as terminosYh8ICVAUY_bv02BzxMh_45dazDt_4FDOHXGiguM7YO_bEMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/legal/terminos.vue?macro=true";
import { default as carta54GryAC18FVVDVAFAABWFWOwYgn_HslMNNPOojr9NXYMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/r/[slug]/carta.vue?macro=true";
import { default as _91vertical_93uWAIQoaNKSdooUIzrCLPOBzSLcrcy6zfXfSm_45zs0cqQMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/para/[vertical].vue?macro=true";
import { default as cuentarRcdcdQx6uFH_45uykaBqGXDSkYW8xt3cZ_pVWadiPE90Meta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/r/[slug]/cuenta.vue?macro=true";
import { default as pedidohoUIpZfooEF8Hw1rIftWvQztXCYPhvHq4FDZtSVrT1kMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/r/[slug]/pedido.vue?macro=true";
import { default as privacidadDsszCiA4l5RES_456a38UsPhC9zG6C3I4I3xWd4O8s77QMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/legal/privacidad.vue?macro=true";
import { default as _91id_93melDlhkMJ9zYTsi_45vwxYkESY3dW5wUJP2SoZ9HABgNYMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/stock/coach/[id].vue?macro=true";
import { default as _91id_93ZbCKVDNycrKC3ZSkDj7N9Vw3WIyurxvvIr62_OKiZQkMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/menu-gestion/[id].vue?macro=true";
import { default as elegir_45restaurantepzzYQduFUHunufvbD2BNEVaXTcJ4IaVidhoe_45WrSVIUMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/elegir-restaurante.vue?macro=true";
import { default as reset_45password1XdfghUiCLucb3OMZJnIyRkimclu4XJoFYA_45v8o2dT0Meta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/auth/reset-password.vue?macro=true";
import { default as barra_45cartaXcmpVT1NgqP3_45V6oWAVdYh1gP2Vl6yIdg0UQVgIDUdAMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/r/[slug]/barra-carta.vue?macro=true";
import { default as barra_45cuentauEwwx49mwgaCn8wTcTcMzemG5Eks8QpM_450SDiWUS16UMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/r/[slug]/barra-cuenta.vue?macro=true";
import { default as barra_45pedido_nmBfz_jpYlY4jq0ySBSYspLlKyjjSx1fMcGL5s_ozMMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/r/[slug]/barra-pedido.vue?macro=true";
import { default as _91zona_93F7T0CDp3hgLK35pYRK_oCSWZ_45wdwtNRj3mW4hZni2MoMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/r/[slug]/barra/[zona].vue?macro=true";
import { default as _91numero_934l5t_Rxdz0SMTJlLw52H0s0QNH7sk2rr89lBgPeBG2cMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/r/[slug]/mesa/[numero].vue?macro=true";
import { default as _91id_93eohM6xRogMyY6hew3yDB0_45FQkOxuUC_aYArWQfvx_GEMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/stock/lista-compra/[id].vue?macro=true";
import { default as _91platoId_93fWAcvLQe4waatwtO3pkHSenwehYqWyC9VlK0uA1AoJAMeta } from "/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/stock/escandallo/[id]/[platoId].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexeerc6nPuGysHs_2M9eoyL6VRlO9SqyghBPG9in5YwwIMeta || {},
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/index.vue")
  },
  {
    name: "caja-id",
    path: "/caja/:id()",
    meta: { ...(_91id_93lpe0miuBzBWZzM_45B8ganKDe_45mZmoqLzL_1R3oXzGTMcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/caja/[id].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexXQE_45CG2PHpAogWsUPJHTyfQo_mGLQg5x2AM1T1URib4Meta || {},
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/auth/index.vue")
  },
  {
    name: "barra-id",
    path: "/barra/:id()",
    meta: { ...(_91id_93kywlAg8q_45gS89vyKovD4MF1hSw5dhEv6we16MPj92SIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/barra/[id].vue")
  },
  {
    name: "mesas-id",
    path: "/mesas/:id()",
    meta: { ...(_91id_937yyh6djsnkOI_45vp0Z3fqtWjsWF3MmTPUY9T9Fko996sMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/mesas/[id].vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: { ...(onboarding4T2bwyhQtVveZ89q9gES_8lTImRYc5CjYqYuYdtk9YUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/onboarding.vue")
  },
  {
    name: "salon-id",
    path: "/salon/:id()",
    meta: { ...(_91id_93_45r_45_45jOpkBSOCdGLrTh9yNXQJOc7tYV3Z0f__wIBvV78Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/salon/[id].vue")
  },
  {
    name: "stock-id",
    path: "/stock/:id()",
    meta: { ...(_91id_93uiyQJ1RbTOyJPz03thIIa0zk_X61hjOSxLrLMSBgcKUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/stock/[id].vue")
  },
  {
    name: "equipo-id",
    path: "/equipo/:id()",
    meta: { ...(_91id_939BmAbi1lYHczflvIv6gaGjCN7g3pWh23HeNt1TLcedwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/equipo/[id].vue")
  },
  {
    name: "multi-local",
    path: "/multi-local",
    meta: { ...(multi_45localLQwEccVAuNRCBWd5Z9zD6IlmikHQA206wHV7nW0fAUQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/multi-local.vue")
  },
  {
    name: "nuevo-local",
    path: "/nuevo-local",
    meta: { ...(nuevo_45local333QLsD3xRb7_0VoYx9B5FjXRHr0LW5jJsa9sl30m_sMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/nuevo-local.vue")
  },
  {
    name: "perfil-id",
    path: "/perfil/:id()",
    meta: {"middleware":["auth"]},
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/perfil/[id].vue")
  },
  {
    name: "recibo-id",
    path: "/recibo/:id()",
    meta: _91id_93ykWJnA_JB3iPwCmpZ9sKHk1IxcVQypXW0yLjU_45d07t8Meta || {},
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/recibo/[id].vue")
  },
  {
    name: "test-sentry",
    path: "/test-sentry",
    meta: test_45sentry57T_YvUG_aVOAsZah5MAZKdi7ftMRuxk9hUMf_as2zgMeta || {},
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/test-sentry.vue")
  },
  {
    name: "ajustes-id",
    path: "/ajustes/:id()",
    meta: { ...(_91id_93TCU8J5_45jkjARKgZ2w8_qaNRKvSZ_45_45qGB_45I0r2y07X4EMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/ajustes/[id].vue")
  },
  {
    name: "auth-confirm",
    path: "/auth/confirm",
    meta: confirmqgE7GQnocGk4kn2wmsAx273YqtGn9djaQWI23aQu6AUMeta || {},
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/auth/confirm.vue")
  },
  {
    name: "pedidos-id",
    path: "/pedidos/:id()",
    meta: { ...(_91id_93gCPeE7mrDUHHTG6oHmCIRrex_451ZbQ6SbDX_pVeYkS5YMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/pedidos/[id].vue")
  },
  {
    name: "legal-cookies",
    path: "/legal/cookies",
    meta: cookiesBd_45YbbIdTtYejfrvjvpzvhS1bbsACLBsuvYyzeo71VUMeta || {},
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/legal/cookies.vue")
  },
  {
    name: "analytics-id",
    path: "/analytics/:id()",
    meta: { ...(_91id_93ZeBZbLd9kBy9I78LAqokSP8CY1G6IGCj7qPpTIdJBbwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/analytics/[id].vue")
  },
  {
    name: "create-profile",
    path: "/create-profile",
    meta: { ...(create_45profilecKP2fQ5zBcdIi9qO0_45Z7f5rKc4voh_BorgyJzlkRw5gMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/create-profile.vue")
  },
  {
    name: "dashboard-id",
    path: "/dashboard/:id()",
    meta: { ...(_91id_93_45ArsxiH_RrJwJT5T1EUMZ_45ydqbfmnaIac07NdcLgg0wMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/dashboard/[id].vue")
  },
  {
    name: "legal-terminos",
    path: "/legal/terminos",
    meta: terminosYh8ICVAUY_bv02BzxMh_45dazDt_4FDOHXGiguM7YO_bEMeta || {},
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/legal/terminos.vue")
  },
  {
    name: "r-slug-carta",
    path: "/r/:slug()/carta",
    meta: carta54GryAC18FVVDVAFAABWFWOwYgn_HslMNNPOojr9NXYMeta || {},
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/r/[slug]/carta.vue")
  },
  {
    name: "para-vertical",
    path: "/para/:vertical()",
    meta: _91vertical_93uWAIQoaNKSdooUIzrCLPOBzSLcrcy6zfXfSm_45zs0cqQMeta || {},
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/para/[vertical].vue")
  },
  {
    name: "r-slug-cuenta",
    path: "/r/:slug()/cuenta",
    meta: cuentarRcdcdQx6uFH_45uykaBqGXDSkYW8xt3cZ_pVWadiPE90Meta || {},
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/r/[slug]/cuenta.vue")
  },
  {
    name: "r-slug-pedido",
    path: "/r/:slug()/pedido",
    meta: pedidohoUIpZfooEF8Hw1rIftWvQztXCYPhvHq4FDZtSVrT1kMeta || {},
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/r/[slug]/pedido.vue")
  },
  {
    name: "legal-privacidad",
    path: "/legal/privacidad",
    meta: privacidadDsszCiA4l5RES_456a38UsPhC9zG6C3I4I3xWd4O8s77QMeta || {},
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/legal/privacidad.vue")
  },
  {
    name: "stock-coach-id",
    path: "/stock/coach/:id()",
    meta: { ...(_91id_93melDlhkMJ9zYTsi_45vwxYkESY3dW5wUJP2SoZ9HABgNYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/stock/coach/[id].vue")
  },
  {
    name: "menu-gestion-id",
    path: "/menu-gestion/:id()",
    meta: { ...(_91id_93ZbCKVDNycrKC3ZSkDj7N9Vw3WIyurxvvIr62_OKiZQkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/menu-gestion/[id].vue")
  },
  {
    name: "elegir-restaurante",
    path: "/elegir-restaurante",
    meta: { ...(elegir_45restaurantepzzYQduFUHunufvbD2BNEVaXTcJ4IaVidhoe_45WrSVIUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/elegir-restaurante.vue")
  },
  {
    name: "auth-reset-password",
    path: "/auth/reset-password",
    meta: reset_45password1XdfghUiCLucb3OMZJnIyRkimclu4XJoFYA_45v8o2dT0Meta || {},
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/auth/reset-password.vue")
  },
  {
    name: "r-slug-barra-carta",
    path: "/r/:slug()/barra-carta",
    meta: barra_45cartaXcmpVT1NgqP3_45V6oWAVdYh1gP2Vl6yIdg0UQVgIDUdAMeta || {},
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/r/[slug]/barra-carta.vue")
  },
  {
    name: "r-slug-barra-cuenta",
    path: "/r/:slug()/barra-cuenta",
    meta: barra_45cuentauEwwx49mwgaCn8wTcTcMzemG5Eks8QpM_450SDiWUS16UMeta || {},
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/r/[slug]/barra-cuenta.vue")
  },
  {
    name: "r-slug-barra-pedido",
    path: "/r/:slug()/barra-pedido",
    meta: barra_45pedido_nmBfz_jpYlY4jq0ySBSYspLlKyjjSx1fMcGL5s_ozMMeta || {},
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/r/[slug]/barra-pedido.vue")
  },
  {
    name: "r-slug-barra-zona",
    path: "/r/:slug()/barra/:zona()",
    meta: _91zona_93F7T0CDp3hgLK35pYRK_oCSWZ_45wdwtNRj3mW4hZni2MoMeta || {},
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/r/[slug]/barra/[zona].vue")
  },
  {
    name: "r-slug-mesa-numero",
    path: "/r/:slug()/mesa/:numero()",
    meta: _91numero_934l5t_Rxdz0SMTJlLw52H0s0QNH7sk2rr89lBgPeBG2cMeta || {},
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/r/[slug]/mesa/[numero].vue")
  },
  {
    name: "stock-lista-compra-id",
    path: "/stock/lista-compra/:id()",
    meta: { ...(_91id_93eohM6xRogMyY6hew3yDB0_45FQkOxuUC_aYArWQfvx_GEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/stock/lista-compra/[id].vue")
  },
  {
    name: "stock-escandallo-id-platoId",
    path: "/stock/escandallo/:id()/:platoId()",
    meta: { ...(_91platoId_93fWAcvLQe4waatwtO3pkHSenwehYqWyC9VlK0uA1AoJAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/pages/stock/escandallo/[id]/[platoId].vue")
  }
]